import { Outlet } from "react-router-dom"

export function ProtectedRoute() {
  // TODO: Implement authentication check
  // const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  // if (!isAuthenticated) {
  //   return <Navigate to="/login" replace />
  // }

  return <Outlet />
}
